<template>
  <div class="pruebas">
    <v-tour name="myTour" :steps="steps" :callbacks="callbacks" :options="options"></v-tour>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-9 col-lg-9" v-show="store.state.btnFinalizar === 0">
          <div id="v-step-2" v-bind:class="{ active: activeStep === 2 }">
            <div class="wrapper-stepper">
              <div class="stepper-content" v-for="(pregunta, i) in store.state.preguntas" :key="i">
                <div class="stepper-pane" v-if="step === i+1" >
                  <div class="examen v-step-2">
                    <h2>Pregunta número: {{ step }}</h2>
                    <p>{{ pregunta.pregunta }}</p>
                    <div class="preguntaMultimedia" v-if="pregunta.urlMultimediaPregunta !== 'null'">
                      <component :is="mediaType(pregunta.urlMultimediaPregunta)" :src="pregunta.urlMultimediaPregunta"
                        :style="{ width: '368px', height: '160px' }" controls autoplay loop></component>
                    </div>
                    <!-- {{responseQuestions}} -->
                    
                    <div class="opciones">
                      <div class="form-check" v-if="pregunta.respuesta[0].urlMultimediaRespuesta  === 'null'">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="opcionA"
                          :value="[pregunta.idBancoPregun, pregunta.respuesta[0].idRespuesta]" v-model="picked"
                          :disabled="store.state.inicioExamen === 0" />
                        <label class="form-check-label" for="opcionA">
                          {{ pregunta.respuesta[0].respuesta }}
                        </label>
                      </div>
                      <div class="form-check" v-if="pregunta.respuesta[1].urlMultimediaRespuesta  ===  'null'">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="opcionB"
                          :value="[pregunta.idBancoPregun, pregunta.respuesta[1].idRespuesta]" v-model="picked"
                          :disabled="store.state.inicioExamen === 0" />
                        <label class="form-check-label" for="opcionB">
                          {{ pregunta.respuesta[1].respuesta }}
                        </label>
                      </div>
                      <div class="form-check" v-if="pregunta.respuesta[2].urlMultimediaRespuesta  ===  'null'">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="opcionC"
                          :value="[pregunta.idBancoPregun, pregunta.respuesta[2].idRespuesta]" v-model="picked"
                          :disabled="store.state.inicioExamen === 0" />
                        <label class="form-check-label" for="opcionC">
                          {{ pregunta.respuesta[2].respuesta }}
                        </label>
                      </div>
                      <div class="form-check" v-if="pregunta.respuesta[3].urlMultimediaRespuesta  ===  'null'">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="opcionD"
                          :value="[pregunta.idBancoPregun, pregunta.respuesta[3].idRespuesta]" v-model="picked"
                          :disabled="store.state.inicioExamen === 0" />
                        <label class="form-check-label" for="opcionD">
                          {{ pregunta.respuesta[3].respuesta }}
                        </label>
                      </div>
                    </div>
                    <!-- opcionesMultimedia -->
                    
                    <div class="opcionesMultimedia">
                      <div class="form-check" v-if="pregunta.respuesta[0].urlMultimediaRespuesta !== 'null' ">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="opcionA"
                          :value="[pregunta.idBancoPregun, pregunta.respuesta[0].idRespuesta]" v-model="picked"
                          :disabled="store.state.inicioExamen === 0" />
                        <label class="form-check-label" for="opcionA">
                          <!-- <img :src="pregunta.respuesta[0].urlMultimediaRespuesta" style="width: 140px; height: 100px;"
                            alt="Imagen de Respuesta"> -->
                          <img
                            v-if="
                            pregunta.respuesta[0].urlMultimediaRespuesta.substring(pregunta.respuesta[0].urlMultimediaRespuesta.length - 3) === 'gif' || 
                            pregunta.respuesta[0].urlMultimediaRespuesta.substring(pregunta.respuesta[0].urlMultimediaRespuesta.length - 3) === 'png' || 
                            pregunta.respuesta[0].urlMultimediaRespuesta.substring(pregunta.respuesta[0].urlMultimediaRespuesta.length - 3) === 'peg' || 
                            pregunta.respuesta[0].urlMultimediaRespuesta.substring(pregunta.respuesta[0].urlMultimediaRespuesta.length - 3) === 'jpg'"
                            :src="pregunta.respuesta[0].urlMultimediaRespuesta" style="width: 140px; height: 100px;"
                            alt="Imagen de respuesta">

                          <video
                            v-if="
                            pregunta.respuesta[0].urlMultimediaRespuesta.substring(pregunta.respuesta[0].urlMultimediaRespuesta.length - 3) === 'mp4' || 
                            pregunta.respuesta[0].urlMultimediaRespuesta.substring(pregunta.respuesta[0].urlMultimediaRespuesta.length - 3) === 'mov' || 
                            pregunta.respuesta[0].urlMultimediaRespuesta.substring(pregunta.respuesta[0].urlMultimediaRespuesta.length - 3) === 'wmv' || 
                            pregunta.respuesta[0].urlMultimediaRespuesta.substring(pregunta.respuesta[0].urlMultimediaRespuesta.length - 3) === 'avi' ||
                            pregunta.respuesta[0].urlMultimediaRespuesta.substring(pregunta.respuesta[0].urlMultimediaRespuesta.length - 3) === 'mkv'"
                             width="150" height="100" :src="pregunta.respuesta[0].urlMultimediaRespuesta" controls
                            autoplay loop>Video no
                            soportado</video>
                          <audio
                            v-if="
                            pregunta.respuesta[0].urlMultimediaRespuesta.substring(pregunta.respuesta[0].urlMultimediaRespuesta.length - 3) === 'mp3' ||
                            pregunta.respuesta[0].urlMultimediaRespuesta.substring(pregunta.respuesta[0].urlMultimediaRespuesta.length - 3) === 'wav' ||
                            pregunta.respuesta[0].urlMultimediaRespuesta.substring(pregunta.respuesta[0].urlMultimediaRespuesta.length - 3) === 'WMA'"
                            :src="pregunta.respuesta[0].urlMultimediaRespuesta" controls autoplay loop></audio>
                        </label>
                      </div>
                      <div class="form-check" v-if="pregunta.respuesta[1].urlMultimediaRespuesta !== 'null' ">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="opcionB"
                          :value="[pregunta.idBancoPregun, pregunta.respuesta[1].idRespuesta]" v-model="picked"
                          :disabled="store.state.inicioExamen === 0" />
                        <label class="form-check-label" for="opcionB">
                          <!-- <img :src="pregunta.respuesta[1].urlMultimediaRespuesta " style="width: 140px; height: 100px;"
                            alt="Imagen de Respuesta"> -->
                            <img
                            v-if="
                            pregunta.respuesta[1].urlMultimediaRespuesta.substring(pregunta.respuesta[1].urlMultimediaRespuesta.length - 3) === 'gif' || 
                            pregunta.respuesta[1].urlMultimediaRespuesta.substring(pregunta.respuesta[1].urlMultimediaRespuesta.length - 3) === 'png' || 
                            pregunta.respuesta[1].urlMultimediaRespuesta.substring(pregunta.respuesta[1].urlMultimediaRespuesta.length - 3) === 'peg' || 
                            pregunta.respuesta[1].urlMultimediaRespuesta.substring(pregunta.respuesta[1].urlMultimediaRespuesta.length - 3) === 'jpg'"
                            :src="pregunta.respuesta[1].urlMultimediaRespuesta" style="width: 140px; height: 100px;"
                            alt="Imagen de respuesta">

                          <video
                            v-if="
                            pregunta.respuesta[1].urlMultimediaRespuesta.substring(pregunta.respuesta[1].urlMultimediaRespuesta.length - 3) === 'mp4' || 
                            pregunta.respuesta[1].urlMultimediaRespuesta.substring(pregunta.respuesta[1].urlMultimediaRespuesta.length - 3) === 'mov' || 
                            pregunta.respuesta[1].urlMultimediaRespuesta.substring(pregunta.respuesta[1].urlMultimediaRespuesta.length - 3) === 'wmv' || 
                            pregunta.respuesta[1].urlMultimediaRespuesta.substring(pregunta.respuesta[1].urlMultimediaRespuesta.length - 3) === 'avi' ||
                            pregunta.respuesta[1].urlMultimediaRespuesta.substring(pregunta.respuesta[1].urlMultimediaRespuesta.length - 3) === 'mkv'"
                             width="150" height="100" :src="pregunta.respuesta[1].urlMultimediaRespuesta" controls
                            autoplay loop>Video no
                            soportado</video>
                          <audio
                            v-if="
                            pregunta.respuesta[1].urlMultimediaRespuesta.substring(pregunta.respuesta[1].urlMultimediaRespuesta.length - 3) === 'mp3' ||
                            pregunta.respuesta[1].urlMultimediaRespuesta.substring(pregunta.respuesta[1].urlMultimediaRespuesta.length - 3) === 'wav' ||
                            pregunta.respuesta[1].urlMultimediaRespuesta.substring(pregunta.respuesta[1].urlMultimediaRespuesta.length - 3) === 'WMA'"
                            :src="pregunta.respuesta[1].urlMultimediaRespuesta" controls autoplay loop></audio>
                        </label>
                      </div>
                      <div class="form-check" v-if="pregunta.respuesta[2].urlMultimediaRespuesta !== 'null' ">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="opcionC"
                          :value="[pregunta.idBancoPregun, pregunta.respuesta[2].idRespuesta]" v-model="picked"
                          :disabled="store.state.inicioExamen === 0" />
                        <label class="form-check-label" for="opcionC">
                          <!-- <img :src="pregunta.respuesta[2].urlMultimediaRespuesta " style="width: 140px; height: 100px;"
                            alt="Imagen de Respuesta"> -->
                            <img
                            v-if="
                            pregunta.respuesta[2].urlMultimediaRespuesta.substring(pregunta.respuesta[2].urlMultimediaRespuesta.length - 3) === 'gif' || 
                            pregunta.respuesta[2].urlMultimediaRespuesta.substring(pregunta.respuesta[2].urlMultimediaRespuesta.length - 3) === 'png' || 
                            pregunta.respuesta[2].urlMultimediaRespuesta.substring(pregunta.respuesta[2].urlMultimediaRespuesta.length - 3) === 'peg' || 
                            pregunta.respuesta[2].urlMultimediaRespuesta.substring(pregunta.respuesta[2].urlMultimediaRespuesta.length - 3) === 'jpg'"
                            :src="pregunta.respuesta[2].urlMultimediaRespuesta" style="width: 140px; height: 100px;"
                            alt="Imagen de respuesta">

                          <video
                            v-if="
                            pregunta.respuesta[2].urlMultimediaRespuesta.substring(pregunta.respuesta[2].urlMultimediaRespuesta.length - 3) === 'mp4' || 
                            pregunta.respuesta[2].urlMultimediaRespuesta.substring(pregunta.respuesta[2].urlMultimediaRespuesta.length - 3) === 'mov' || 
                            pregunta.respuesta[2].urlMultimediaRespuesta.substring(pregunta.respuesta[2].urlMultimediaRespuesta.length - 3) === 'wmv' || 
                            pregunta.respuesta[2].urlMultimediaRespuesta.substring(pregunta.respuesta[2].urlMultimediaRespuesta.length - 3) === 'avi' ||
                            pregunta.respuesta[2].urlMultimediaRespuesta.substring(pregunta.respuesta[2].urlMultimediaRespuesta.length - 3) === 'mkv'"
                             width="150" height="100" :src="pregunta.respuesta[2].urlMultimediaRespuesta" controls
                            autoplay loop>Video no
                            soportado</video>
                          <audio
                            v-if="
                            pregunta.respuesta[2].urlMultimediaRespuesta.substring(pregunta.respuesta[2].urlMultimediaRespuesta.length - 3) === 'mp3' ||
                            pregunta.respuesta[2].urlMultimediaRespuesta.substring(pregunta.respuesta[2].urlMultimediaRespuesta.length - 3) === 'wav' ||
                            pregunta.respuesta[2].urlMultimediaRespuesta.substring(pregunta.respuesta[2].urlMultimediaRespuesta.length - 3) === 'WMA'"
                            :src="pregunta.respuesta[2].urlMultimediaRespuesta" controls autoplay loop></audio>
                        </label>
                      </div>
                      <div class="form-check" v-if="pregunta.respuesta[3].urlMultimediaRespuesta !== 'null'">
                        <input class="form-check-input" type="radio" name="flexRadioDefault" id="opcionD"
                          :value="[pregunta.idBancoPregun, pregunta.respuesta[3].idRespuesta]" v-model="picked"
                          :disabled="store.state.inicioExamen === 0" />
                        <label class="form-check-label" for="opcionD">
                          <img v-if="isFileType(pregunta.respuesta[3].urlMultimediaRespuesta, 'image')"
                            :src="pregunta.respuesta[3].urlMultimediaRespuesta" style="width: 140px; height: 100px;"
                            alt="Imagen de respuesta">
                          <video v-if="isFileType(pregunta.respuesta[3].urlMultimediaRespuesta, 'video')" width="150" height="100"
                            :src="pregunta.respuesta[3].urlMultimediaRespuesta" controls autoplay loop>Video no soportado</video>
                          <audio v-if="isFileType(pregunta.respuesta[3].urlMultimediaRespuesta, 'audio')"
                            :src="pregunta.respuesta[3].urlMultimediaRespuesta" controls autoplay loop></audio>
                        </label>
                      </div>
                    </div>
                    <div>
                    </div>
                  </div>
                  <br /><br />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-9 col-lg-9" v-if="showFinalizationMessage">
          <h2>Finalización examen teórico</h2>
          <p>Preguntas respondidas {{ store.state.contadorPreguntas }} de {{ store.state.numerpreguntas }}</p>
        </div>
        <div class="col-12 col-3 col-lg-3">
          <div id="v-step-0" v-bind:class="{ active: activeStep === 0 }">
            <div class="tiempo v-step-0">
              <h3>Tiempo restante</h3>
              <br />
              <Timer />
              <br />
              <Reloj />
            </div>
          </div>
        </div>
        <div class="controls">
          
          <button class="btn v-step-3" v-on:click="questionsAnswers(); enviarRespuesta()"  @click.prevent="addStep(-1, true)"
            :disabled="store.state.inicioExamen === 0  || step === 1 ||  step === store.state.numerpreguntas + 1 ||  store.state.btnFinalizar === 2">
            Anterior
          </button>
          <div id="v-step-1" class="not-active" v-bind:class="{ active: activeStep === 1 }">
            <div class="stepper v-step-1" v-for="(pregunta, index) in store.state.preguntas" :key="index">
              <div id="steps" class="stepper-item"
                :class="{ 'current': step === index + 1, 'success': store.state.isQuestionAnswered.some(el => el.IdBancoPregun === pregunta.idBancoPregun) === true }">
                <div class="stepper-item-counter ">
                  <span class="" @click="questionsAnswers">
                    <a href="" @click.prevent="addStep(index + 1, false)"> <span>{{index + 1}}</span></a>
                  </span>
                </div>
              </div>
            </div>  
          </div>
          <div id="v-step-3" v-bind:class="{ active: activeStep === 3 }">
            <!-- <button id="downloadPhoto" class="btn v-step-3" @click.prevent="addStep(1, true)" v-on:click="questionsAnswers(); enviarRespuesta()"  -->
            <button id="downloadPhoto" class="btn v-step-3" @click.prevent="addStep(1, true)" v-on:click="questionsAnswers(); enviarRespuesta()" 
            v-if="store.state.btnFinalizar != 2" :disabled=" store.state.inicioExamen === 0 || step === store.state.numerpreguntas + 1 ||  store.state.btnFinalizar === 2 ">
              Siguiente
            </button>
          </div>
          <div id="v-step-4" v-bind:class="{ active: activeStep === 4 }">
            <button v-if="store.state.btnFinalizar === 0" class="btn v-step-4 btnFinalizar" @click="finishExam"
              :disabled="store.state.inicioExamen === 0">
              Finalizar examen
            </button>
            <div class="volverExamen">
              <button v-if="store.state.btnFinalizar === 2" class="btn v-step-4"  @click="volverPrueba"
              :disabled="store.state.inicioExamen === 2 ">
              Volver a examen
            </button>

            <button v-if="store.state.btnFinalizar === 2" class="btn v-step-4" @click="saveExam">
              Enviar examen
            </button>
            </div>
           
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-10 col-lg-10 ">
            <div class="number-res">
              <p>Respuestas {{store.state.contadorPreguntas}} de {{store.state.numerpreguntas}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <video ref="camera" :width="width" :height="height" autoplay style="display:none"></video>
  <canvas id="photoTaken" ref="canvas" :width="width" :height="height" style="display:none"></canvas>
</template>

<script src="@/layouts/Examen/Pruebas-Tecnicas"></script>
<style  lang="scss" >
@import "@/fonts/fonts.scss";
@import "./Pruebas-Tecnicas.scss";
</style>